import { render, staticRenderFns } from "./MatchClientHomeStep.vue?vue&type=template&id=46cdc554"
import script from "./MatchClientHomeStep.vue?vue&type=script&lang=js"
export * from "./MatchClientHomeStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports